import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { IonicModule } from "ionic-angular";
import { StripeManager } from "../../managers/stripe.manager";
import { StripeButtonComponent } from "./stripe-button.component";

@NgModule({
  declarations: [StripeButtonComponent],
  imports: [CommonModule, IonicModule, TranslateModule],
  exports: [StripeButtonComponent],
  providers: [StripeManager],
})
export class StripeButtonModule {}



// WEBPACK FOOTER //
// ./src/app/components/stripe-button/stripe-button.module.ts